import React, { Component } from 'react'
import Schema from 'components/Schema'
import Helmet from 'react-helmet'
import { config } from 'config'
import 'app/base.scss'

export default class Template extends Component {
  metaTitle = config.default_title
  metaDescription = config.default_description

  render() {
    return (
      <div>
        <Helmet
          htmlAttributes={{'lang': 'en'}}
          title={this.metaTitle}
          meta={[
            {'name': 'description', 'content': this.metaDescription},

            { name: 'og:title', content: this.metaTitle },
            { name: 'og:description', content: this.metaDescription },
            { name: 'og:url', content: this.url },
            { name: 'og:site_name', content: config.name },
            { name: 'og:type', content: 'website' },
            { name: 'og:local', content: 'en_US' },
            { name: 'og:image', content: config.logo },

            { name: 'twitter:card', content: 'summary' },
            { name: 'twitter:site', content: config.twitter },
            { name: 'twitter:site:id', content: config.twitter_id },
            { name: 'twitter:title', content: this.metaTitle },
            { name: 'twitter:description', content: this.metaDescription },
            { name: 'twitter:domain', content: config.name },
            { name: 'twitter:image', content: config.logo },

            { name: 'msapplication-TileColor', content: '#FFFFFF' },
            { name: 'msapplication-TileImage', content: '/assets/favicons/smalltile.png' },
          ]}
          link={[
            {'rel': 'canonical', 'href': `${config.url}${this.props.location.pathname}`},
            { rel: 'shortcut icon', href: '/favicons/favicon.ico', type: 'image/x-icon' },
            { rel: 'icon', href: '/favicons/favicon.ico', type: 'image/x-icon' },
            { rel: 'apple-touch-icon', sizes: '57x57', href: '/favicons/favicon-57.png' },
            { rel: 'apple-touch-icon', sizes: '144x144', href: '/favicons/favicon-144.png' },
          ]}
        />

        <main>
          {this.props.children}
        </main>

        <Schema />
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./_template.js
 **/